import React from "react";
import Navbar from "./Navbar";

// 시안용 예시 이미지 (프로젝트 폴더에 이미 있는 파일 사용)
import banner from "../assets/layout/images/project_bim_banner.jpg";
import digital from "../assets/layout/images/project_bim_digital.png";
import manager from "../assets/layout/images/project_bim_manager.png";
import revit from "../assets/layout/images/project_bim_revit.png";
// 필요 시 파일만 교체하면 됩니다.

const Project_bmi = () => {
  const bmiItem = [
    {
      id: "digital",
      icon: digital,
      title: "지하차도, 특수 시설물 관리",
      desc: "360도 카메라와, 지도 정보를 연계한 VR 기술을 통해 지하차도의 구조와 설비를 디지털 환경에서 실시간으로 관리할 수 있습니다."
    },
    {
      id: "manager",
      icon: manager,
      title: "아이템 매니저",
      desc: "교량부터 소규모 설비까지 모든 시설물의 자산을 누락 없이 디지털로 등록하고​ 항상 최신 상태로 현행화하여 스마트 자산관리를 실현합니다"
    },
    {
      id: "revit",
      icon: revit,
      title: "Revit기반 BIM 기술",
      desc: "Revit 기반 BIM(Building Information Modeling) 기술을 활용하여, 구조물의 설계부터 시공·운영·유지관리까지 전 과정에서 정확하고 신속한 진단을 지원합니다."
    }
  ]

  return (
    <>
      <Navbar detail />
      <section className="detail">
        <div className="container-lg" style={{ maxWidth: 1200, paddingTop: 0 }}>
          {/* Breadcrumb */}
          <nav className="mb-3">
            <a href="/#project" className="menu-link me-2">Business</a>
            <span className="text-muted">›</span>
            <strong className="menu-title ms-2">지능형 시설물 관리 시스템</strong>
          </nav>

          {/* Title */}
          <div className="banner">
            <h1 className="detail-title">지능형 시설물 관리 시스템</h1>
            <figure className="banner-figure full-bleed">
              <img 
                className="banner-img" 
                src={banner}
                alt="컨택센터 배너이미지"
              />
            </figure>
          </div>
          <div className="detail-desc">
            아미소프트는 교량과 지하차도를 비롯한 다양한 구조물을 스마트하게 진단하고 관리하는 지능형 시설물 관리 시스템을 제공합니다. Revit 기반BIM과 VR 기술등을 이용하여 시설물의 상태를 실시간으로 수집·분석하고, 정밀한 진단과 예측 기반 유지관리를 지원합니다. 이를 통해 안전성과 효율성을 동시에 확보하며, 현장과 사무환경 어디서나 편리하게 활용할 수 있는 차세대 통합 솔루션을 제공합니다
          </div>

          <div className="detail-items">
            {bmiItem.map((i) => (
              <div className="detail-item" key={i.id}>
                <h1 className="item-title">{i.title}</h1>
                <div className="item-desc">
                  {i.desc}
                </div>
                <figure className="item-figure" >
                  <img 
                    className="item-img" 
                    src={i.icon} 
                    alt={`${i.title} 예시`}
                  />
                </figure>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Project_bmi;
